import { BaseQueryParams, IResponsePaginate } from '@/types';
import { Scenario, ScenarioDto, Step, StepDto, ModeEvaluationFinalResponse, ScenarioModeEvaluationFinalRequest } from '@/types/scenarios.types';
import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Steps } from 'node_modules/primeng/steps/public_api';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class DacScenarioService {
  SCENARIOS_URL = `${environment.api.paramsUrl}/scenarios`;
  STEPS_URL = `${environment.api.paramsUrl}/etapes`;
  httpClient = inject(HttpClient);

  create(scenario: ScenarioDto): Observable<Scenario> {
    return this.httpClient.post<Scenario>(`${this.SCENARIOS_URL}`, scenario);
  }

  getOne(id: number): Observable<Scenario> {
    return this.httpClient.get<Scenario>(`${this.SCENARIOS_URL}/${id}`);
  }

  update(id: number, scenario: ScenarioDto): Observable<Scenario> {
    return this.httpClient.put<Scenario>(`${this.SCENARIOS_URL}/${id}`, scenario);
  }

  getAll(query?: BaseQueryParams): Observable<IResponsePaginate<Scenario>> {
    return this.httpClient.get<IResponsePaginate<Scenario>>(`${this.SCENARIOS_URL}/page`, { params: { ...query } });
  }

  getByDac(dacId: number, dacVer: number): Observable<Scenario[]> {
    return this.httpClient.get<Scenario[]>(`${this.SCENARIOS_URL}/by-dac/${dacId}/${dacVer}`);
  }

  createStep(scenarioId: number, stepDto: StepDto): Observable<Scenario> {
    return this.httpClient.post<Scenario>(`${this.SCENARIOS_URL}/etapes`, {
      scenarioId,
      ...stepDto,
    });
  }

  deleteStep(scenarioId: number, stepDto: StepDto): Observable<Scenario> {
    return this.httpClient.delete<Scenario>(`${this.SCENARIOS_URL}/etapes`, {
      body: {
        scenarioId,
        etapeId: stepDto.etapeId,
        typeDossierId: stepDto.typeDossierId,
      },
    });
  }
  getSteps(): Observable<Step[]> {
    return this.httpClient.get<Step[]>(`${this.STEPS_URL}`);
  }

  getAvailableSteps(scenarioId: number): Observable<Step[]> {
    return this.httpClient.get<Step[]>(`${this.STEPS_URL}/available/${scenarioId}`);
  }

  getStepById(stepId: number): Observable<Steps> {
    return this.httpClient.get<Steps>(`${this.STEPS_URL}/${stepId}`);
  }

  changeActive(id: number): Observable<Scenario> {
    return this.httpClient.put<Scenario>(`${this.SCENARIOS_URL}/${id}/change-activation`, {});
  }

  getAvailableModeEvaluationFinal(scenarioId: number): Observable<ModeEvaluationFinalResponse[]> {
    return this.httpClient.get<ModeEvaluationFinalResponse[]>(`${this.SCENARIOS_URL}/${scenarioId}/available-mode-evaluation-final`);
  }

  updateModeEvaluationFinal(request: ScenarioModeEvaluationFinalRequest): Observable<Scenario> {
    return this.httpClient.put<Scenario>(`${this.SCENARIOS_URL}/mode-evaluation-final`, request);
  }
}
